export function validateBradesco(accountNumber, givenCheckDigit) {
  return calculateBradescoDigit(accountNumber) == givenCheckDigit;
}

function calculateBradescoDigit(accountNumber) {
  const pesos = [2, 7, 6, 5, 4, 3, 2];
  const contaSemDV = accountNumber.padStart(7, '0'); // Obtém a conta sem o DV
  
  let soma = 0;

  // Multiplica cada dígito pelo seu peso correspondente
  for (let i = 0; i < contaSemDV.length; i++) {
    soma += contaSemDV[i] * pesos[i % pesos.length];
  }

  // Calcula o dígito verificador
  const resto = soma % 11;
  const dvCalculado = (resto == 0 || resto == 1) ? 0 : (11 - resto);

  // Verifica se o DV informado é igual ao DV calculado
  return dvCalculado.toString();
}